import { Component, OnInit, NgZone } from '@angular/core';
import { UsersService } from '@app/shared/services/users.service';
import { trigger, transition, style, animate } from '@angular/animations';

const ALL_TICKET_STATUS = 0;
const OPEN_TICKET_STATUS = 1;
const CLOSED_TICKET_STATUS = 2;

@Component({
  selector: 'app-client-support',
  templateUrl: './client-support.component.html',
  styleUrls: ['./client-support.component.scss'],
  animations: [
    trigger(
      'toRight', [
        transition(':enter', [
          style({transform: 'translateX(-100%)', opacity: 0}),
          animate('250ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1}),
          animate('250ms', style({transform: 'translateX(-100%)', opacity: 0}))
        ])
      ]
    ),
    trigger(
      'toLeft', [
        transition(':enter', [
          style({transform: 'translateX(100%)', opacity: 0}),
          animate('250ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1}),
          animate('250ms', style({transform: 'translateX(100%)', opacity: 0}))
        ])
      ]
    )
  ]
})
export class ClientSupportComponent implements OnInit {

  /* Filters */

  public status: number = ALL_TICKET_STATUS;
  public user : any = {};
  public loading : boolean = false;
  public userSet : boolean = false;
  public userSearch : string = '';
  public userSelected : number = 0;
  public userOptions : any = [];
  public userDisplay : boolean = false;
  public noResult : boolean = false;
  public _timeout : any = null;

  /* Tickets */

  public tickets: any = [];
  public ticket: any = {};
  public animationDisabled: boolean = true;
  public view: string = 'list';

  constructor(
    private userService: UsersService,
    private lc: NgZone
  ) { }

  ngOnInit(): void {
    /* retrieve tickets */
    this.tickets = [{
      id: 402,
      status: OPEN_TICKET_STATUS,
      ISODateCreation: '2020-03-15T12:02:56.0000000Z',
      ISODateLastChange: '2020-03-15T15:02:56.0000000Z',
      idReservation: 102563,
      idUser: 164,
      idVehicle: 101,
      vehicle: 'FJ-302-FK',
      user: 'Manon Auvray',
      messages: [{
        author: 'Manon Auvray',
        ISODateCreation: '2020-03-15T12:02:56.0000000Z',
        admin: false,
        content: 'Je n\'arrive pas à ouvrir la voiture',
      },{
        author: 'Olivier de Broissia',
        ISODateCreation: '2020-03-15T15:02:56.0000000Z',
        admin: true,
        content: 'Il faut appuyer sur le bouton',
      }]
    },{
      id: 403,
      status: CLOSED_TICKET_STATUS,
      ISODateCreation: '2020-03-03T21:02:44.0000000Z',
      ISODateLastChange: '2020-03-03T09:15:56.0000000Z',
      idReservation: 101996,
      idUser: 161,
      idVehicle: 101,
      vehicle: 'FJ-302-FK',
      user: 'Mustapha Pinta',
      messages: [{
        author: 'Mustapha Pinta',
        ISODateCreation: '2020-03-03T21:02:44.0000000Z',
        admin: false,
        content: 'Je n\'arrive pas à ouvrir la voiture',
      },{
        author: 'Olivier de Broissia',
        ISODateCreation: '2020-03-03T09:15:56.0000000Z',
        admin: true,
        content: 'Il faut appuyer sur le bouton',
      }]
    }];
  }

  ngAfterViewInit(): void {
    window.setTimeout(() => {
      this.animationDisabled = false;
    });
  }

  resetVariables() {
    this.user = {};
    this._timeout = null;
    this.noResult = false;
    this.loading = false;
    this.userSet = false;
    this.userSearch = '';
    this.userSelected = 0;
    this.userOptions = [];
    this.userDisplay = false;
  }

  updateUserOptionList(event) {
    if (this._timeout) {
      window.clearTimeout(this._timeout);
    }
    this._timeout = window.setTimeout(() => {
      this._timeout = null;
      this.lc.run(() => {
        this.userSearch = event;
        this.loading = true;
        this.noResult = false;
        this.userService.updateUsers(1, this.userSearch).then((res) => {
          if (res.length > 0) {
            this.userOptions = res;
          } else {
            this.noResult = true;
          }
          this.loading = false;
        });
      });
    }, 1000);
  }

  setUserSearch(option) {
    this.user = option;
    this.userSet = true;
    this.userSearch = option.FirstName + ' ' + option.LastName;
  }

  toggleSuggestions(shouldDisplay) {
    setTimeout(() => {
      this.userDisplay = shouldDisplay;
    }, 250);
  }

  toggleMessageView(ticket) {
    this.view = '';
    this.ticket = ticket;
    setTimeout(() => { this.view = 'details'; }, 250);
  }

  toggleListView() {
    this.view = '';
    setTimeout(() => { this.view = 'list'; }, 250);
  }

}
